import { appDispatch } from '../../../redux/store-accessors';
import { useCreateImportAttachmentsJobMutation } from '../../../redux/services/file';
import { showInfo, showError, dismiss } from '../../../services/notification.service';
import { useTranslation } from 'react-i18next';
import { submitImportAttachmentsJob } from '../../../redux/slices/background-job-slice';
import { useRef } from 'react';

const useImportAttachments = () => {
  const toastIdRef = useRef<string | undefined>(undefined);
  const { t } = useTranslation();

  const [createImportJob] = useCreateImportAttachmentsJobMutation();

  const startImportAttachmentsJob = (file: File, prefix?: 'RECORD_ID' | 'RECORD_SOURCE_ID') => {
    toastIdRef.current = showInfo(t('import-attachments-starting'), { duration: Infinity, showCloseIcon: true });

    createImportJob()
      .unwrap()
      .then((response) => {
        fetch(response.presignedUrl, {
          method: 'PUT',
          body: file,
        })
          .then(() => {
            dismiss(toastIdRef.current);
            toastIdRef.current = undefined;

            appDispatch(submitImportAttachmentsJob({ jobId: response.id, prefix }));
          })
          .catch(() => {
            dismiss(toastIdRef.current);
            toastIdRef.current = undefined;

            showError(t('import-attachments-failed'));
          });
      });
  };

  return {
    startImportAttachmentsJob,
  };
};

export default useImportAttachments;
